import { useLocation } from "react-router-dom";

export function Footer({ onNavigate, isGuest }) {
  // El texto de presentación solo lo ve quien todavía no tiene cuenta, y solo
  // en la puerta de entrada: "/" (home) o "/explore" (donde cae quien pulsa
  // "Explorar sin cuenta"). Si ya has iniciado sesión no te hace falta el
  // discurso de qué es esto en ninguna página, incluida tu propia home.
  const { pathname } = useLocation();
  const isLanding = isGuest && (pathname === "/" || pathname === "/explore");

  return (
    <footer style={{ background:"#fff", color:"rgba(0,0,0,0.6)", marginTop:48, padding:"32px 0 24px", borderTop:"1px solid #eee" }}>
      <div style={{ maxWidth:900, margin:"0 auto", padding:"0 20px" }}>
        {isLanding&&(
          <p style={{ fontSize:13, lineHeight:1.7, color:"rgba(0,0,0,0.5)", maxWidth:420, marginBottom:24 }}>La red social de los amantes de los relojes. Gestiona tu colección, descubre nuevos modelos y conecta con la comunidad relojera.</p>
        )}
        <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", flexWrap:"wrap", gap:10 }}>
          <div style={{ fontSize:12, color:"rgba(0,0,0,0.4)" }}>
            © {new Date().getFullYear()} Wwatch. Todos los derechos reservados. Hecho con cuidado por{" "}
            <a href="https://bay-apps.com" target="_blank" rel="noreferrer" style={{ color:"rgba(0,0,0,0.55)", textDecoration:"underline" }}>Bay Apps</a>.
          </div>
          <div style={{ display:"flex", gap:16 }}>
            <button onClick={()=>onNavigate("privacidad")} style={{ background:"none", border:"none", cursor:"pointer", padding:0, fontSize:12, color:"rgba(0,0,0,0.4)", fontFamily:"'Geist',sans-serif" }}>Privacidad</button>
            <button onClick={()=>onNavigate("terminos")} style={{ background:"none", border:"none", cursor:"pointer", padding:0, fontSize:12, color:"rgba(0,0,0,0.4)", fontFamily:"'Geist',sans-serif" }}>Términos</button>
          </div>
        </div>
      </div>
    </footer>
  );
}
